import { DeleteWithToken, GetWithToken, PostWithToken, PatchWithToken } from "../../lib/request";

export const createNewAd = (data) => {
    return async function (dispatch) {
        const result = await PostWithToken('/v2/admin/ads', data);
        return result;
    }
}

export const getAllAds = (query) => {
    return async function (dispatch) {
        const placement = query?.placement || 'top-header';
        const limit = query?.limit || 10;
        const offset = query?.offset || 0;
        const result = await GetWithToken(`/v2/admin/ads?placement=${placement}&limit=${limit}&offset=${offset}`);
        return result;
    }
}

export const getAdById = (id) => {
    return async function (dispatch) {
        const result = await GetWithToken(`/v2/admin/ads/${id}`);
        return result;
    }
}

export const updateAdById = (id, data) => {
    return async function (dispatch) {
        const result = await PatchWithToken(`/v2/admin/ads/${id}`, data);
        return result;
    }
}

export const deleteAdById = (id) => {
    return async function (dispatch) {
        const result = await DeleteWithToken(`/v2/admin/ads/${id}`);
        return result;
    }
}
